module.exports = __webpack_public_path__ + "img/cary-with-domains.c74d6314.png";